import React from "react";
import SettingsIcon from "@material-ui/icons/Settings";

import { connMeta } from "./theme";

// Topbar: logo "C"/"CRM" + pill de status da conexão + engrenagem de configurações.
// Ancoragem do popover por posição (via onOpenSettings).
const TopBar = ({ V, connected, onOpenSettings }) => {
  const conn = connMeta(connected);
  const soft = V.key === "c";

  const pillStyle = soft
    ? {
        background: "rgba(255,255,255,.6)",
        border: "1px solid rgba(255,255,255,.85)",
        borderRadius: 999,
      }
    : V.key === "b"
      ? { background: "#F4F6F9", borderRadius: 7 }
      : {
          background: "#fff",
          border: "1px solid #E8DFCE",
          borderRadius: 999,
        };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 18px",
        background: V.topbarBg,
        borderBottom: V.topbarBorder,
        flex: "none",
      }}
    >
      <span
        style={{
          width: 28,
          height: 28,
          borderRadius: V.logoRadius,
          background: V.prim,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 900,
          fontSize: 14,
        }}
      >
        C
      </span>
      <span style={{ fontWeight: 900, fontSize: 15, color: V.textStrong }}>
        CRM
      </span>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 12px",
          fontSize: 11.5,
          fontWeight: 800,
          color: conn.col,
          ...pillStyle,
        }}
      >
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: conn.dot,
          }}
        />
        {conn.text}
      </span>
      <span style={{ flex: 1 }} />
      <button
        type="button"
        onClick={onOpenSettings}
        title="Configurações"
        style={{
          background: "transparent",
          border: "none",
          color: V.labelMuted,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          padding: 4,
        }}
      >
        <SettingsIcon style={{ fontSize: 20 }} />
      </button>
    </div>
  );
};

export default TopBar;
